import { handleChange, setSearch } from 'feature/form/formSlice';
import {
	setDownloadAll,
	setPaymentExcludeIds,
	setPaymentsIds,
} from 'feature/payments/paymentsSlice';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as SearchHideIcon } from 'assett/icons/search_hide_icon.svg';
import { ReactComponent as SearchIcon } from 'assett/icons/search_icon.svg';
import HeaderCellWithSorting from 'components/commons/list/HeaderCellWithSorting';
import useDevice from 'hooks/DesktopDevice.hook';
import { AppDispatch, RootState } from 'store/store';
import { IconButton, TableCell, TableHead, TableRow } from 'styles';
import Box from 'styles/box/Box';
import Checkbox from 'styles/checkbox/Checkbox';
import DatePicker from 'styles/datePicker/DatePicker';
import { useTranslation } from 'utils/translations';

const PaymentsHeader = () => {
	const { downloadAll } = useSelector((store: RootState) => store.payments);

	const inputForm = useSelector((store: RootState) => store.form);
	const { search, inputDateOfService } = useSelector(
		(store: RootState) => store.form,
	);
	const { isDesktop } = useDevice();
	const dispatch = useDispatch<AppDispatch>();
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});

	const handleCheckDownload = () => {
		if (downloadAll) {
			dispatch(setDownloadAll(false));
			dispatch(setPaymentsIds([]));
			dispatch(setPaymentExcludeIds([]));
		} else {
			dispatch(setDownloadAll(true));
		}
	};

	return (
		<TableHead>
			<TableRow>
				<TableCell sx={{ width: 220, zIndex: '90!important' }}>
					<Checkbox
						label=""
						onClick={handleCheckDownload}
						checked={downloadAll}
						sx={{ p: 0 }}
						accessibilitylabel={`${tClientLabels(
							'payment.labels.selectAllPayments',
						)}`}
					/>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<HeaderCellWithSorting
						name="paymentRunDate"
						widthBox={220}
						widthInput={220}
						noMargins
					>
						<Box sx={{ width: 220 }}>
							<DatePicker
								variant="field"
								label={tClientLabels('forms.header.paymentRunDate')}
								value={inputDateOfService}
								onChange={value => {
									dispatch(
										handleChange<any>({
											name: 'inputDateOfService',
											value: value,
										}),
									);
								}}
							/>
						</Box>
					</HeaderCellWithSorting>
				</TableCell>
				<TableCell>
					<HeaderCellWithSorting
						name="paymentRunId"
						value={inputForm.inputPaymentRunId || ''}
						widthBox={220}
						widthInput={220}
						noMargins
					/>
				</TableCell>
				<TableCell>
					<HeaderCellWithSorting
						name="totalAmount"
						value={String(inputForm.inputTotalAmount || '')}
						widthBox={220}
						widthInput={220}
						noMargins
					/>
				</TableCell>
				<TableCell sx={{ width: '100%', textAlign: 'right' }}>
					<IconButton
						onClick={() => dispatch(setSearch(!search))}
						sx={{ ml: !!isDesktop ? 0 : 4.2 }}
						aria-label={`${tClientLabels('commons.buttons.search')}`}
					>
						{search ? <SearchHideIcon /> : <SearchIcon />}
					</IconButton>
				</TableCell>
			</TableRow>
		</TableHead>
	);
};

export default PaymentsHeader;
